import React, { useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/member/giftcardValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { GiftCardDataContext } from "../giftCard";

axios.defaults.baseURL = API;

function CreateGiftCard(props) {

    const {dataList, setDataList, userID } = useContext(GiftCardDataContext);

    const handleInputChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
    };

    const handleInputNameChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.GiftCardNO.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckGiftCardNO", results[0].GiftCardNO);
        else
            handleChange("CheckGiftCardNO", "");
    }

    async function saveTutorial() {
        let token = localStorage.getItem("token");
        var data = {
            GiftCardNO: values.GiftCardNO,
            Price: values.Price,
            StatusID: 1,
            CreateByID: userID,
            CreateDate: new Date(),
        }
        await axios.post("/createGiftCard", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            var obj = {
                GiftCardID: response?.data?.insertId,
                GiftCardNO: values.GiftCardNO,
                Price: values.Price,
                StatusID: 1,
                CreateByID: userID,
                CreateDate: new Date(),
            }
            dataList.push(obj);
            setDataList(dataList);
            localStorage.setItem("giftCardData", JSON.stringify(dataList));
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("GiftCardNO", "");
        handleChange("Price", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(saveTutorial, validate);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ສ້າງຂໍ້ມູນບັດ GiftCard</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <span>GiftCardNO:</span>
                                <input className={`input form-control ${errors.GiftCardNO && 'is-invalid'}`} type="text" name="GiftCardNO" onChange={(e) => handleInputNameChange(e)} value={values.GiftCardNO || ''} required />
                                {errors.GiftCardNO && (
                                    <p className="invalid-feedback">{errors.GiftCardNO}</p>
                                )}
                            </div>
                            <div className="form-group">
                                <span>Price:</span>
                                <input className={`input form-control ${errors.Price && 'is-invalid'}`} type="text" name="Price" onChange={(e) => handleInputChange(e)} value={values.Price || ''} required />
                                {errors.Price && (
                                    <p className="invalid-feedback">{errors.Price}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateGiftCard;
